module.exports = __webpack_public_path__ + "src/assets/img/rambler.f911afb1.jpg";